// plugins/tracking.js
// plugins are configured to be loaded in to the client-side pack
// and assume that jQuery is present on window
import track from 'lib/tracking/track';

document.addEventListener('DOMContentLoaded', () => {
  window.Trailhead = window.Trailhead || {};
  window.Trailhead.ActivityTracking = { track };
});
